import React from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection({ heading, subheading }) {
  return (
    <div style={styles.hero}>
      <div style={styles.circle1} />
      <div style={styles.circle2} />

      <div style={styles.content}>
        <div style={styles.badge}>🌿 Willkommen in der Natur</div>
        <h1 style={styles.heading}>{heading}</h1>
        <p style={styles.subheading}>{subheading}</p>
        <div style={styles.actions}>
          <Link to="/buchung" style={styles.ctaPrimary}>Jetzt anfragen</Link>
          <Link to="/galerie" style={styles.ctaSecondary}>Galerie ansehen</Link>
        </div>
      </div>

      <div style={styles.waveWrapper}>
        <svg viewBox="0 0 1440 80" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{ display: 'block', width: '100%', height: '80px' }}>
          <path d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z" fill="#f0f7f2"/>
        </svg>
      </div>
    </div>
  );
}

const styles = {
  hero: {
    position: 'relative',
    overflow: 'hidden',
    background: 'linear-gradient(145deg, #1b4332 0%, #2d6a4f 45%, #40916c 100%)',
    minHeight: '520px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  circle1: {
    position: 'absolute',
    top: '-80px',
    right: '-80px',
    width: '400px',
    height: '400px',
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.05)',
    pointerEvents: 'none',
  },
  circle2: {
    position: 'absolute',
    bottom: '-100px',
    left: '-60px',
    width: '350px',
    height: '350px',
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.04)',
    pointerEvents: 'none',
  },
  content: {
    position: 'relative',
    zIndex: 2,
    textAlign: 'center',
    padding: '4rem 2rem 6rem',
    maxWidth: '740px',
  },
  badge: {
    display: 'inline-block',
    backgroundColor: 'rgba(255,255,255,0.15)',
    color: 'rgba(255,255,255,0.92)',
    padding: '0.4rem 1.1rem',
    borderRadius: '50px',
    fontSize: '0.88rem',
    fontFamily: "'Nunito', Arial, sans-serif",
    fontWeight: '700',
    letterSpacing: '0.5px',
    marginBottom: '1.2rem',
    border: '1px solid rgba(255,255,255,0.2)',
  },
  heading: {
    color: 'white',
    fontSize: 'clamp(2rem, 5.5vw, 3.4rem)',
    fontFamily: "'Nunito', Arial, sans-serif",
    fontWeight: '800',
    lineHeight: '1.18',
    marginBottom: '1rem',
    textShadow: '0 2px 12px rgba(0,0,0,0.2)',
    letterSpacing: '-0.5px',
  },
  subheading: {
    color: 'rgba(255,255,255,0.85)',
    fontSize: 'clamp(1rem, 2.5vw, 1.25rem)',
    fontFamily: "'Nunito', Arial, sans-serif",
    fontWeight: '400',
    marginBottom: '2.2rem',
    lineHeight: '1.65',
  },
  actions: {
    display: 'flex',
    gap: '1rem',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  ctaPrimary: {
    display: 'inline-block',
    backgroundColor: '#ffd166',
    color: '#1b4332',
    textDecoration: 'none',
    padding: '0.9rem 2.4rem',
    borderRadius: '50px',
    fontWeight: '800',
    fontSize: '1.05rem',
    fontFamily: "'Nunito', Arial, sans-serif",
    boxShadow: '0 4px 20px rgba(255,209,102,0.4)',
  },
  ctaSecondary: {
    display: 'inline-block',
    backgroundColor: 'rgba(255,255,255,0.15)',
    color: 'white',
    textDecoration: 'none',
    padding: '0.9rem 2.4rem',
    borderRadius: '50px',
    fontWeight: '700',
    fontSize: '1.05rem',
    fontFamily: "'Nunito', Arial, sans-serif",
    border: '2px solid rgba(255,255,255,0.4)',
  },
  waveWrapper: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1,
  },
};
